import { TypeOfWork } from './candidate/type-of-work';
import { CareType } from './employer/care-type';

const CARE_TYPE_TYPE_OF_WORK_MAPPING = [
  {
    careType: [CareType.Hospital, CareType.RehabClinic],
    typeOfWork: TypeOfWork.Hospital,
  },
  {
    careType: [CareType.Ambulant],
    typeOfWork: TypeOfWork.Ambulant,
  },
  {
    careType: [CareType.IntensiveAmbulant, CareType.IntensiveStationary],
    typeOfWork: TypeOfWork.Intensive,
  },
  {
    careType: [CareType.Stationary, CareType.Hospice],
    typeOfWork: TypeOfWork.NursingHome,
  },
  {
    careType: [CareType.DentalPractice],
    typeOfWork: TypeOfWork.DentalPractice,
  },
  {
    careType: [CareType.DoctorOffice],
    typeOfWork: TypeOfWork.DoctorOffice,
  },
  {
    careType: [CareType.Leasing],
    typeOfWork: TypeOfWork.Leasing,
  },
  {
    careType: [CareType.OutpatientPractice],
    typeOfWork: TypeOfWork.OutpatientPractice,
  },
  {
    careType: [CareType.UniversityHospital],
    typeOfWork: TypeOfWork.UniversityHospital,
  },
  {
    careType: [CareType.PrivateClinic],
    typeOfWork: TypeOfWork.PrivateClinic,
  },
  {
    careType: [CareType.MedicalCareCenter],
    typeOfWork: TypeOfWork.MedicalCareCenter,
  },
  {
    careType: [CareType.Physiotherapy],
    typeOfWork: TypeOfWork.Physiotherapy,
  },
];

export const mapCareTypeToTypeOfWork = (careType?: CareType): TypeOfWork | undefined =>
  careType && CARE_TYPE_TYPE_OF_WORK_MAPPING.find(a => a.careType.includes(careType))?.typeOfWork;

export const mapTypeOfWorkToCareType = (typeOfWork?: TypeOfWork): CareType[] | undefined =>
  typeOfWork && CARE_TYPE_TYPE_OF_WORK_MAPPING.find(a => a.typeOfWork === typeOfWork)?.careType;
